
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BenefitsList extends Vue {
  get heading() {
    return this.$t(
      'components.nodes.benefitsList.thePowerOfOwnership',
    ) as string;
  }

  get body() {
    return this.$t('components.nodes.benefitsList.whileWeWill') as string;
  }

  get benefits() {
    return [
      {
        img: require(`@/assets/nodes/benefits-thumb-1.png`),
        header: this.$t('components.nodes.benefitsList.own') as string,
        body: this.$t('components.nodes.benefitsList.youDontNeed') as string,
      },
      {
        img: require(`@/assets/nodes/benefits-thumb-2.png`),
        header: this.$t('components.nodes.benefitsList.empower') as string,
        body: this.$t(
          'components.nodes.benefitsList.supportProjects',
        ) as string,
      },
      {
        img: require(`@/assets/nodes/benefits-thumb-3.jpg`),
        header: this.$t('components.nodes.benefitsList.earn') as string,
        body: this.$t('components.nodes.benefitsList.seeAPilot') as string,
      },
    ];
  }
}
